// src/api/axiosInstance.js
import axios from "axios";

const api = axios.create({
  baseURL: import.meta.env.VITE_COREFLOW_API_URL,
  withCredentials: true, // if you need cookies
});

export default api; // ✅ default export
